module.exports = __webpack_public_path__ + "./docs/img/big-icon-method.3a12fcaf387b3eda36e34d7f396ec120.svg";